import { useQuery } from "@tanstack/react-query";
// API
import API from "./Api";

export const fetchAllOrders = async () => {
  const res = await API.get("api/get-all-order");
  return res.data;
};

export default function useGetAllOrdersApi() {
  return useQuery({
    queryKey: ["AllOrders"],
    queryFn: () => fetchAllOrders(),
  });
}
